<template>
    <div class="header">
        <header class="logo-and-nav" :class="{opened: isMenuOpened}">
            <router-link to="/" class="logo">
                <img class="logo-img" src="../../images/icon/logo-new.png" title="annto">
            </router-link>
            <nav class="nav">
                <ul class="nav-list">
                    <li
                        v-for="(mainMenu, index) in menu"
                        :key="mainMenu.name"
                        @mouseover="showMenu(mainMenu.name)"
                        @mouseout="hideMenu()"
                        v-show="mainMenu.name!=='provision'"
                        :class="{cur: curNavIndex === index}"
                    >
                        <router-link v-if="index === 0" to="/">{{mainMenu.text}}</router-link>
                        <span v-else>{{mainMenu.text}}</span>
                    </li>
                </ul>
            </nav>
            <a
                id="menu-btn"
                class="menu-btn"
                v-show="mobileWidth"
                :class="{opened: isMenuOpened}"
                @click="openMenu"
            ></a>
            <!-- <router-link
                :to="{name: 'branch'}"
                v-if="mobileWidth"
                class="branch-btn"
                id="branch-btn"
                :class="{hidden: isMenuOpened}"
            ></router-link> -->
        </header>
        <div class="navigation-down" v-bind:class="{opened: isMenuOpened}" v-if="!mobileWidth">
            <div
                class="nav-down-menu"
                v-for="mainItem in menu"
                :key="mainItem.name"
                v-show="curId===mainItem.name"
                @mouseover="showMenu(mainItem.name)"
                @mouseleave="hideMenu()"
            >
                <div class="menu-con-nav">
                    <dl v-for="subMenu in mainItem.subMenu" :key="subMenu.name">
                        <dt :class="{hasSubMenu: subMenu.children}">{{subMenu.meta.text}}</dt>
                        <dd
                            v-for="item in subMenu.children"
                            :key="item.name"
                            :data-main-item="subMenu.name"
                            @click="hideMenuQuick"
                        >
                            <a :href="item.path" v-if="item.path.indexOf('//') > -1" target="_blank">{{item.meta.text}}</a>
                            <router-link :to="{name: item.name}" v-else>{{item.meta.text}}</router-link>
                        </dd>
                    </dl>
                </div>
            </div>
        </div>
        <div class="navigation-down" v-bind:class="{opened: isMenuOpened}" v-else>
            <div class="nav-down-menu" v-for="mainItem in menu" :key="mainItem.name">
                <div class="menu-con-nav">
                    <dl
                        v-for="(subMenu, index) in mainItem.subMenu"
                        :key="subMenu.name"
                        v-show="mainItem.name!=='provision'&&mainItem.name!=='solution'"
                    >
                        <dt
                            :class="{hasSubMenu: subMenu.children}"
                            @click="showSubMenu(subMenu.name)"
                            :id="subMenu.name"
                        >
                            <router-link v-if="index === 0" to="/">{{subMenu.meta.text}}</router-link>
                            <span v-else>{{subMenu.meta.text}}</span>
                        </dt>
                        <dd
                            v-for="item in subMenu.children"
                            :key="item.name"
                            :data-main-item="subMenu.name"
                            @click="hideSubMenu"
                        >
                            <router-link :to="{name: item.name}">{{item.meta.text}}</router-link>
                        </dd>
                    </dl>
                </div>
            </div>
            <div class="contact-us" v-show="mobileWidth">
                <dl>
                    <dt>联系我们</dt>
                    <dd>
                        <div class="hot-line">
                            <span>服务&投诉电话</span>
                            <a href="tel:400-000-0056" class="tel-num">400-000-0056</a>
                        </div>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>

<style lang="less">
@import url(./style/header.less);
</style>

<script>
export default {
    name: 'main-header',
    props: ['mobileWidth'],
    data() {
        return {
            timer: null,
            menu: [],
            curId: '',
            isMenuOpened: false,
            isLogisticsMenu: false,
            isServiceMenu: false,
            isAboutMenu: false,
            isMobile: this.COMMON.isMobile,
            curNavIndex: 0,
            resolution: {
                name: 'solution',
                text: '解决方案',
                subMenu: [
                    {
                        children: [
                            {
                                name: 'xiaoan',
                                path: 'https://xiaoan.annto.com',
                                meta: { text: '送装一体' }
                            },
                            {
                                name: 'ltlway',
                                path: 'https://ltlway.annto.com',
                                meta: { text: '零担系统' }
                            },
                            {
                                name: 'lms',
                                path: 'https://wb.annto.com/index',
                                meta: { text: '大物流系统' }
                            }
                        ],
                        meta: { text: '解决方案' }
                    }
                ]
            }
        };
    },
    mounted() {
        this.initMenu();
        this.curRouteName = this.$route.path;
        if (this.mobileWidth) {
            this.initMobileMenu();
        }
    },
    methods: {
        initMenu() {
            this.menu = this.processMenuData(
                this.$router.options.routes.filter(item => item.meta)
            );
        },
        initMobileMenu() {
            const that = this;
            document
                .querySelector('#menu-btn')
                .addEventListener('click', function() {
                    that.isMenuOpened = !that.isMenuOpened;
                });
        },
        showMenu(name) {
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.curId = name;
        },
        hideMenu() {
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(() => {
                this.curId = '';
            }, 500);
        },
        hideMenuQuick() {
            if (this.isMobile) {
                this.curId = '';
            }
        },
        showSubMenu(menuName) {
            if (menuName === 'main-index') {
                this.hideSubMenu();
                return true;
            }
            document.getElementById(menuName).classList.toggle('opened');
            let subMenu = document.querySelectorAll(
                '[data-main-item=' + menuName + ']'
            );
            subMenu.forEach(item => item.classList.toggle('shown'));
        },
        hideSubMenu() {
            document.querySelector('#menu-btn').click();
        },
        processMenuData(arr) {
            // 抽取主菜单
            const tempArr1 = arr.map(item => {
                return {
                    text: item.meta.mainMenuText,
                    name: item.meta.mainMenu,
                    subMenu: []
                };
            });
            const tempArr2 = [];

            // 去重
            for (let i = 0; i < tempArr1.length; i++) {
                let flag = true;
                for (let j = 0; j < tempArr2.length; j++) {
                    if (tempArr1[i].name === tempArr2[j].name) {
                        flag = false;
                    }
                }
                if (flag) {
                    tempArr2.push(tempArr1[i]);
                }
            }

            // 挂载二级菜单
            for (let i = 0; i < tempArr2.length; i++) {
                for (let j = 0; j < arr.length; j++) {
                    if (arr[j].meta.mainMenu === tempArr2[i].name) {
                        tempArr2[i].subMenu.push(arr[j]);
                    }
                }
            }
            // 增加解决方案
            tempArr2.splice(3, 0, this.resolution);
            return tempArr2;
        },
        openMenu() {
            window.scrollTo(0, 0);
        }
    },
    watch: {
        $route(to) {
            let navIndex = this.menu.findIndex(item => {
                let hasMenu = false;
                for (var i = item.subMenu.length - 1; i >= 0; i--) {
                    if (
                        item.subMenu[i].path !== '/' &&
                        to.path.includes(item.subMenu[i].path)
                    ) {
                        hasMenu = true;
                    }
                }
                return hasMenu;
            });
            this.curNavIndex = navIndex && navIndex > 0 ? navIndex : 0;
        }
    }
};
</script>

